import * as Config from '../../../config';
import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import './Cart.css';

import Spinner from '../common/Spinner';

import useGetOne from '../../../hooks/useGetOne';

function ConnectedCartPlaylistInfo({ api, counter }) {
  const { item } = useGetOne(api, '/v4/my/default-cart/', counter);
  return item ? (           
    <span>{(item && item.summary && item.summary.item_count) ? (item.summary.item_count === Config.MAX_CART_ITEMS ? 'Cart is full' : `${item.summary.item_count} tracks`) : '0 tracks'} • {item.summary.price.total.display}</span>
  ) : <Spinner className={'mini'} />
}

ConnectedCartPlaylistInfo.propTypes = {
  api: PropTypes.any, 
  counter: PropTypes.any
}

const CartPlaylistInfo = connect(
  state => ({
    api: state.api,
    counter: state.cartCounter
  })
)(ConnectedCartPlaylistInfo);

export default CartPlaylistInfo;
